export class ReadStatusCacheService {
  private static readonly DB_NAME = 'BibleReadStatus';
  private static readonly DB_VERSION = 1;
  private static readonly STORE_NAME = 'readStatus';

  static async openDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.DB_NAME, this.DB_VERSION);
      
      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
      
      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains(this.STORE_NAME)) {
          const store = db.createObjectStore(this.STORE_NAME, { keyPath: 'key' });
          store.createIndex('version', 'version', { unique: false });
          store.createIndex('bookCode', 'bookCode', { unique: false });
        }
      };
    });
  }

  static generateReadStatusKey(
    version: string,
    bookCode: string,
    chapter: number,
    verseStart: number,
    verseEnd: number
  ): string {
    return `${version},${bookCode},${chapter},${verseStart},${verseEnd}`;
  }

  static async markAsRead(
    version: string,
    bookCode: string,
    chapter: number,
    verseStart: number,
    verseEnd: number
  ): Promise<void> {
    try {
      const db = await this.openDB();
      const transaction = db.transaction([this.STORE_NAME], 'readwrite');
      const store = transaction.objectStore(this.STORE_NAME);

      const key = this.generateReadStatusKey(version, bookCode, chapter, verseStart, verseEnd);
      const readStatus = {
        key,
        version,
        bookCode,
        chapter,
        verseStart,
        verseEnd,
        readAt: new Date().toISOString()
      };

      await new Promise<void>((resolve, reject) => {
        const request = store.put(readStatus);
        request.onerror = () => reject(request.error);
        request.onsuccess = () => resolve();
      });

      console.log('읽음 상태 저장 완료:', key);
    } catch (error) {
      console.error('읽음 상태 저장 중 오류:', error);
      throw error;
    }
  }

  static async isRead(
    version: string,
    bookCode: string,
    chapter: number,
    verseStart: number,
    verseEnd: number
  ): Promise<boolean> {
    try {
      const db = await this.openDB();
      const transaction = db.transaction([this.STORE_NAME], 'readonly');
      const store = transaction.objectStore(this.STORE_NAME);

      const key = this.generateReadStatusKey(version, bookCode, chapter, verseStart, verseEnd);
      
      const result = await new Promise<any>((resolve, reject) => {
        const request = store.get(key);
        request.onerror = () => reject(request.error);
        request.onsuccess = () => resolve(request.result);
      });

      return !!result;
    } catch (error) {
      console.error('읽음 상태 조회 중 오류:', error);
      return false;
    }
  }

  static async getReadStatusCount(): Promise<number> {
    try {
      const db = await this.openDB();
      const transaction = db.transaction([this.STORE_NAME], 'readonly');
      const store = transaction.objectStore(this.STORE_NAME);

      const count = await new Promise<number>((resolve, reject) => {
        const request = store.count();
        request.onerror = () => reject(request.error);
        request.onsuccess = () => resolve(request.result);
      });

      return count;
    } catch (error) {
      console.error('읽음 상태 개수 조회 중 오류:', error);
      return 0;
    }
  }

  static async clearAllReadStatus(): Promise<void> {
    try {
      const db = await this.openDB();
      const transaction = db.transaction([this.STORE_NAME], 'readwrite');
      const store = transaction.objectStore(this.STORE_NAME);

      await new Promise<void>((resolve, reject) => {
        const request = store.clear();
        request.onerror = () => reject(request.error);
        request.onsuccess = () => resolve();
      });

      console.log('전체 읽음 상태 삭제 완료');
    } catch (error) {
      console.error('읽음 상태 삭제 중 오류:', error);
      throw error;
    }
  }
}
